import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const InteractionDealsModelSchema = z
  .object({
    id: z.string(),
    interaction_id: z.string(),
    deal_id: z.string()
  })
  .strict()

export const InteractionDealsModelFields = makeFieldKeys(InteractionDealsModelSchema)

export type InteractionDealsModel = z.infer<typeof InteractionDealsModelSchema>

function validateInteractionDealsModel(data: unknown): InteractionDealsModel {
  try {
    return validateWithZodSchema(InteractionDealsModelSchema, data, 'interaction deals model')
  } catch (error) {
    throw new Error(`Interaction deals model validation failed: ${error}`)
  }
}
